// extracted by mini-css-extract-plugin
export default {"abilitiesSectionRoot":"abilitiessection_abilitiesSectionRoot__bJfTJ","sectionContainer":"abilitiessection_sectionContainer__WeY9I"};